import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";



function FacturasTiendasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_SERIES_FISCAL = import.meta.env.VITE_URL_SERIES_FISCAL;
  const URL_TIMBRAR = import.meta.env.VITE_URL_TIMBRAR;
  const URL_FACTURAS = import.meta.env.VITE_URL_FACTURAS;
  const URL_ARTICULOS_VENTAS_TIENDAS =
    import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_EMPRESAS = import.meta.env.VITE_URL_EMPRESAS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const CLIENTES_DIVERSOS = import.meta.env.VITE_CLIENTE_DIVERSOS;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  const { idVenta } = useParams();

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [timbresDisponibles, setTimbresDisponibles] = useState(0);

  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalCant, setTotalCant] = useState(0);
  const [descuentoPorcentaje, setDescuentoPorcentaje] = useState(0);
  const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [cpEmpresa, setCpEmpresa] = useState("");
  const [rfcEmpresa, setRfcEmpresa] = useState("");
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [regFiscalEmpresa, setRegFiscalEmpresa] = useState("");

  const [condicionesPagoSATCliente, setCondicionesPagoSATCliente] =
    useState("");
  const [formaPagoSATCliente, setFormaPagoSATCliente] = useState("04");
  const [metodoPagoSATCliente, setMetodoPagoSATCliente] = useState("PUE");
  const [rfcCliente, setRfcCliente] = useState("");
  const [nombreCliente, setNombreCliente] = useState("");
  const [usoCFDICliente, setUsoCFDICliente] = useState("");
  const [regFiscalCliente, setRegFiscalCliente] = useState("");
  const [cpCliente, setCpCliente] = useState("");

  const [serie, setSerie] = useState("A");
  // Serie fiscal REAL de la tienda (se lee de SeriesFiscal por área). El dropdown viejo
  // mostraba "A" fija, que no es la serie que realmente usa la factura de tienda.
  const [serieTienda, setSerieTienda] = useState("");


  const [inputFields, setInputFields] = useState([]);

  const [surtidosData, setSurtidosData] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);

  const [facturarPublicoGeneral, setFacturarPublicoGeneral] = useState(false);
  const [datosClientePrevios, setDatosClientePrevios] = useState({});
  // Evita que el useEffect cargue la venta más de una vez cuando clientes.length cambia
  const ventaLoadedRef = useRef(false);
  // Marca si el usuario ingresó datos fiscales manualmente en el modal
  // Usamos ref (no state) para evitar stale closures: los closures async siempre leen el valor actual
  const billingOverriddenRef = useRef(false);
  const submittingRef = useRef(false);
  const [billingOverridden, setBillingOverridden] = useState(false);

  const [modalCustomFactura, setModalCustomFactura] = useState(false);
  const toggleCustomFactura = () => setModalCustomFactura(!modalCustomFactura);

  useEffect(() => {
    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SERIES_FISCAL}Timbres`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTimbres = res.data;
        setTimbresDisponibles(allTimbres[0].folio);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_EMPRESAS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });

    // Serie fiscal REAL de esta tienda (por área). Se muestra de solo lectura.
    axios
      .get(`${URL_SERIES_FISCAL}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const all = res.data || [];
        const s = all.find((x) => String(x.areas) === String(user.areas));
        if (s) {
          setSerieTienda(s.serie);
          setSerie(s.serie);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_COLABORADORES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    if (idVenta && clientes.length > 0 && !ventaLoadedRef.current) {
      ventaLoadedRef.current = true;
      axios
        .get(`${URL_VENTAS_TIENDAS}/${idVenta}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(async (res) => {
          const venta = res.data;
          setSelectedCliente(venta.clientes[0]._id);
          BuscaCliente(venta.clientes[0]._id);
          // Vendedor REAL de la venta (no el del cliente)
          if (venta.colaboradores && venta.colaboradores[0]) {
            setSelectedColaborador(venta.colaboradores[0]._id || venta.colaboradores[0]);
          }
          // (Se quitó un forzado a "01 Efectivo" cuando venta.deposito > 0: ese campo no
          // existe en VentasTiendas —0 documentos lo tienen— y además contradice que la
          // forma de pago la elija quien factura.)

          // Setear InputFields
          let arrayVenta = [
            {
              id: uuidv4(),
              surtidos: venta._id,
              idSurtido: venta.prefijo + " " + venta.consecutivo,
              total: parseFloat(venta.total_general),
              totalCantidad: venta.total_cantidad,
            },
          ];

          setInputFields(arrayVenta);

          // Detecta si esta venta ya tiene una factura en BD (para ofrecer reintento de timbrado)
          const fId = Array.isArray(venta.facturas)
            ? (venta.facturas[0]?._id || venta.facturas[0])
            : (venta.facturas?._id || venta.facturas);
          if (venta.facturado === "Si" && fId) {
            setFacturaExistenteId(String(fId));
          }

          let tcan = arrayVenta.map((c) => parseFloat(c.totalCantidad));
          let TDCan = tcan.reduce((t, total, index) => t + total, 0);
          setTotalCant(TDCan);

          // Usar valores ya calculados y guardados en BD
          let descPorcentaje = parseFloat(venta.descuento) || 0;
          setDescuentoPorcentaje(descPorcentaje);
          setDescuentoNumero(parseFloat(venta.subTotal) * descPorcentaje / 100);
          setSubTotal(parseFloat(venta.subTotal));
          setIva(parseFloat(venta.iva || 0));
          setTotal(parseFloat(venta.total_general));
          // Jala Articulos

          const response = await axios.get(
            `${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${idVenta}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          if (!response.data.length) {
            console.warn("La API no devolvió datos");
            return;
          }

          let allArticulosSurtido = response.data;
          let colorTallaCantidad = {};

          allArticulosSurtido.forEach((a) => {
            const color = a.colores[0].name;
            const talla = a.tallas[0].name;
            const cantidad = a.cantidad;

            if (!colorTallaCantidad[talla]) {
              colorTallaCantidad[talla] = {};
            }
            if (!colorTallaCantidad[talla][color]) {
              colorTallaCantidad[talla][color] = 0;
            }
            colorTallaCantidad[talla][color] += cantidad;
          });

          const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
            const indexA = customSizeOrder.indexOf(a);
            const indexB = customSizeOrder.indexOf(b);
            return (
              (indexA === -1 ? Infinity : indexA) -
              (indexB === -1 ? Infinity : indexB)
            );
          });

          const colores = [
            ...new Set(allArticulosSurtido.map((a) => a.colores[0].name)),
          ].sort();

          setSurtidosData(
            tallas.map((talla) => {
              // Buscar el primer artículo con esta talla
              const articulo = allArticulosSurtido.find(
                (a) => a.tallas[0]?.name === talla
              );

              return {
                talla,
                nombreArticulo:
                  articulo?.articulos?.[0]?.nombre || "Desconocido",
                precio: articulo?.precio || 0,
                colores: colores.map((color) => ({
                  color,
                  cantidad: colorTallaCantidad[talla]?.[color] || 0,
                })),
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [idVenta, clientes.length]);

  // --- Mensajes de error claros al facturar / timbrar -------------------------
  // El SAT (vía Facturama) rechaza por datos concretos del receptor: RFC, régimen
  // fiscal, uso de CFDI, forma de pago, CP o nombre. Antes se mostraba
  // "Something went wrong!" y el usuario solo podía reintentar en vano, porque un
  // dato mal capturado no se arregla solo. Ahora se muestra el dato exacto.

  // Saca el texto del error que quedó guardado en la factura (respuestaFacturama).
  const textoErrorFacturama = (resp) => {
    const o = Array.isArray(resp) ? resp[resp.length - 1] : resp;
    if (!o) return "";
    if (typeof o === "string") return o;
    if (o.ModelState) return Object.values(o.ModelState).flat().join(" ");
    return o.Message || o.message || o.error || "";
  };

  // Saca el texto del error de una respuesta HTTP (backend propio o Facturama).
  const detalleError = (error) => {
    const d = error?.response?.data;
    if (!d) return error?.message || String(error);
    if (typeof d === "string") return d;
    if (Array.isArray(d.errores) && d.errores.length) return d.errores.join(" ");
    if (d.ModelState) return Object.values(d.ModelState).flat().join(" ");
    return (
      d.message ||
      d.Message ||
      d.error ||
      textoErrorFacturama(d.respuestaFacturama) ||
      error?.message ||
      JSON.stringify(d)
    );
  };

  // Errores de datos fiscales: reintentar NUNCA los resuelve, hay que corregir el cliente.
  const esErrorDeDatos = (texto = "") =>
    /rfc|r[ée]gimen|uso ?cfdi|uso de cfdi|forma de pago|c[óo]digo postal|nombre del receptor|receptor|dato[s]? fiscal/i.test(
      texto
    );

  const swalErrorFactura = (error, titulo = "No se pudo timbrar la factura") => {
    const detalle = detalleError(error);
    Swal.fire({
      icon: "error",
      title: titulo,
      html:
        `<div style="text-align:left">${detalle}</div>` +
        (esErrorDeDatos(detalle)
          ? `<br/><div style="text-align:left"><b>Reintentar no va a funcionar.</b> Corrija estos datos del cliente (Catálogo de Clientes / Constancia de Situación Fiscal) y vuelva a facturar.</div>`
          : ""),
    });
    console.log(error);
  };

  const saveFacturaNuevo = async (event) => {
    event.preventDefault();

    // Candado de doble clic: se toma INMEDIATAMENTE. Antes se tomaba hasta
    // después de los pre-checks asíncronos, y dos clics con milisegundos de
    // diferencia entraban los dos (así se duplicaron CFDIs en el SAT). Todo
    // camino que no termina en recarga de página debe liberarlo.
    if (submittingRef.current) return;
    submittingRef.current = true;

    // --- PRE-CHECK: datos fiscales del cliente antes de consumir un folio ---
    // Si faltan o son inválidos, el SAT rechaza y ningún reintento lo arregla:
    // se avisa el dato exacto en vez de dejar que falle el timbrado.
    const vacio = (v) => v === undefined || v === null || String(v).trim() === "";

    // La forma y el método de pago se eligen aquí mismo (dependen de cómo pagó el
    // cliente esta compra, no del catálogo), así que se piden aparte de los datos
    // que sí hay que corregir en Catálogos → Clientes.
    const faltanEnPantalla = [
      { valor: formaPagoSATCliente, label: "Forma de Pago Fiscal" },
      { valor: metodoPagoSATCliente, label: "Método de Pago Fiscal" },
    ]
      .filter((c) => vacio(c.valor))
      .map((c) => c.label);
    if (faltanEnPantalla.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Seleccione la forma de pago",
        html:
          `Falta indicar en esta pantalla:<br/><br/><b>${faltanEnPantalla.join("<br/>")}</b>` +
          `<br/><br/>Elija cómo pagó el cliente (01 Efectivo, 03 Transferencia, 04 Tarjeta...). ` +
          `El SAT lo exige y no se puede corregir después de timbrar.`,
      });
      submittingRef.current = false;
      return;
    }

    const faltantes = [
      { valor: rfcCliente, label: "RFC" },
      { valor: nombreCliente, label: "Nombre / Razón Social" },
      { valor: regFiscalCliente, label: "Régimen Fiscal" },
      { valor: usoCFDICliente, label: "Uso de CFDI" },
      { valor: cpCliente, label: "Código Postal" },
    ]
      .filter((c) => vacio(c.valor))
      .map((c) => c.label);
    if (faltantes.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Faltan datos fiscales del cliente",
        html:
          `No se puede facturar, al cliente le falta capturar:<br/><br/><b>${faltantes.join("<br/>")}</b>` +
          `<br/><br/>Complételos en <b>Catálogos → Clientes</b> y vuelva a intentar.`,
      });
      submittingRef.current = false;
      return;
    }
    if (metodoPagoSATCliente === "PUE" && formaPagoSATCliente === "99") {
      Swal.fire({
        icon: "warning",
        title: "Forma de pago inválida",
        html:
          `Con <b>Método de Pago PUE</b> el SAT no acepta la Forma de Pago <b>99 (Por definir)</b>.<br/><br/>` +
          `Seleccione la forma real (01 Efectivo, 03 Transferencia, 04 Tarjeta...) o corrija el cliente en <b>Catálogos → Clientes</b>.`,
      });
      submittingRef.current = false;
      return;
    }

    // --- PRE-CHECK: detectar factura existente antes de crear una nueva ---
    // SIEMPRE se re-verifica contra la BD el/los ticket(s) que están seleccionados en este
    // momento. NO se usa el estado `facturaExistenteId` como atajo: ese estado sobrevive a
    // cambios de cliente/ticket dentro de la misma pantalla y disparaba el swal sobre ventas
    // que no tienen ninguna factura (caso reportado en N-4522, limpio en BD).
    let existingFacturaId = "";
    let ticketConFactura = "";

    for (const field of inputFields) {
      if (!field.surtidos) continue;
      try {
        const res = await axios.get(`${URL_VENTAS_TIENDAS}/${field.surtidos}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        const v = res.data;
        if (v.facturado === "Si") {
          const fId = Array.isArray(v.facturas)
            ? (v.facturas[0]?._id || v.facturas[0])
            : (v.facturas?._id || v.facturas);
          if (fId) {
            existingFacturaId = String(fId);
            ticketConFactura =
              field.idSurtido || `${v.prefijo || ""}-${v.consecutivo || ""}`;
            break;
          }
        }
      } catch (e) {
        // Si el endpoint falla, se ignora el pre-check y se continúa normalmente
        console.warn("Pre-check factura existente:", e);
      }
    }

    // Si hay factura existente, mostrar POR QUÉ no se timbró antes y sólo entonces
    // ofrecer reintentar. Si el motivo es un dato fiscal mal capturado, reintentar
    // es inútil (el SAT lo va a rechazar igual), así que se dice explícitamente.
    if (existingFacturaId) {
      let motivoPrevio = "";
      try {
        const resFac = await axios.get(`${URL_FACTURAS}/${existingFacturaId}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        motivoPrevio = textoErrorFacturama(resFac.data?.respuestaFacturama);
      } catch (e) {
        console.warn("No se pudo leer el motivo del fallo previo:", e);
      }

      const bloqueoPorDatos = motivoPrevio && esErrorDeDatos(motivoPrevio);

      const confirm = await Swal.fire({
        title: "Factura existente detectada",
        html:
          (ticketConFactura
            ? `El ticket <b>${ticketConFactura}</b> ya tiene una factura registrada en el sistema.`
            : "Esta venta ya tiene una factura registrada en el sistema.") +
          (motivoPrevio
            ? `<br/><br/><div style="text-align:left"><b>El intento anterior falló por:</b><br/>${motivoPrevio}</div>`
            : "") +
          (bloqueoPorDatos
            ? `<br/><div style="text-align:left;color:#d33"><b>Reintentar no va a funcionar</b> hasta corregir ese dato en el Catálogo de Clientes (Constancia de Situación Fiscal).</div>`
            : "") +
          "<br/><br/>¿Deseas <b>reintentar solo el timbrado</b> sin crear una nueva factura?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: bloqueoPorDatos ? "Reintentar de todos modos" : "Reintentar Timbrado",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) {
        submittingRef.current = false;
        return;
      }

      setValidaBoton(false);
      toggleProgreso();
      try {
        await axios.post(
          `${URL_TIMBRAR}FacturaVentaTienda`,
          { facturas: existingFacturaId },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        await axios.post(
          URL_LOGS,
          { tipo: "Reintentar Timbrado", detalle: `Reintento timbrado factura ${existingFacturaId}`, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        Swal.fire("Good job!", "Timbrado con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
      } catch (error) {
        // 409 = el backend detectó que la factura YA estaba timbrada (candado anti-duplicado).
        // No es un error: se evitó un CFDI duplicado. Avisamos y recargamos.
        if (error?.response?.status === 409) {
          await Swal.fire({
            icon: "info",
            title: "Ya estaba timbrada",
            text: "Esta factura ya había sido timbrada previamente. No se generó un duplicado.",
          });
          window.location.reload();
          return;
        }
        swalErrorFactura(error);
        submittingRef.current = false;
        setValidaBoton(true);
        setModalProgreso(false);
      }
      return;
    }
    // --- FIN PRE-CHECK ---

    if (timbresDisponibles > 0) {
      Swal.fire({
        title: "Estas seguro?",
        text: "Se guardará la Factura!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, guardar!",
      }).then(async (result) => {
        // El candado ya se tomó al entrar a saveFacturaNuevo; si el usuario
        // cancela hay que liberarlo o el botón queda bloqueado.
        if (!result.isConfirmed) {
          submittingRef.current = false;
          return;
        }
        if (subTotal > 0 && total > 0) {
          setValidaBoton(false);
          toggleProgreso();

          let totalArticulos = inputFields.length;
          try {
            await axios
              .post(
                URL_FACTURAS,
                {
                  fecha,
                  observaciones,
                  totalCantidad: totalCant,
                  subTotal: parseFloat(subTotal.toFixed(2)),
                  iva: parseFloat(iva.toFixed(2)),
                  total: parseFloat(total.toFixed(2)),
                  abonos: 0,
                  saldo: parseFloat(total.toFixed(2)),
                  pagado: "No",
                  descuentoPorcentaje1: descuentoPorcentaje,
                  descuentoNumero1: descuentoNumero,
                  descuentoConcepto1: descuentoPorcentaje > 0 ? "Descuento comercial" : "NA",
                  descuentoPorcentaje2: 0,
                  descuentoNumero2: 0,
                  descuentoConcepto2: "NA",
                  empresas: selectedEmpresa,
                  clientes: selectedCliente,
                  colaboradores: selectedColaborador,
                  timbre: "No",
                  currency: "MXN",
                  cfdiType: "I",
                  areas: user.areas,

                  expeditionPlace: cpEmpresa,

                  rfcEmpresa,
                  nombreEmpresa,
                  regFiscalEmpresa,

                  condicionesPagoSATCliente,
                  formaPagoSATCliente,
                  metodoPagoSATCliente,
                  rfcCliente,
                  nombreCliente,
                  usoCFDICliente,
                  regFiscalCliente: String(regFiscalCliente),
                  cpCliente: String(cpCliente),

                  numeroPagos: 0,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
                inputFields.map((w) => {
                  axios
                    .patch(
                      `${URL_VENTAS_TIENDAS}Factura/${w.surtidos}`,
                      {
                        facturas: data.data._id,
                        facturado: "Si",
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      totalArticulos = totalArticulos - 1;
                      if (totalArticulos == 0) {
                        axios
                          .post(
                            `${URL_TIMBRAR}FacturaVentaTienda`,
                            {
                              facturas: data.data._id,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          )
                          .then(() => {
                            axios
                              .post(
                                URL_LOGS,
                                {
                                  tipo: "Crear Factura",
                                  detalle: `Fecha Factura ${fecha} ${data.data.idFactura}`,
                                  user: user.id,
                                },
                                {
                                  headers: {
                                    Authorization: `Bearer: ${localStorage.getItem(
                                      "app_token"
                                    )}`,
                                  },
                                }
                              )
                              .then(() => {
                                Swal.fire(
                                  "Good job!",
                                  "Creado con exito",
                                  "success"
                                );
                                setTimeout(() => {
                                  window.location.reload();
                                }, 1000);
                              })
                              .catch((error) => {
                                swalErrorFactura(error);
                                submittingRef.current = false;
                                setValidaBoton(true);
                                setModalProgreso(false);
                              });
                          })
                          .catch((error) => {
                            swalErrorFactura(error);
                            submittingRef.current = false;
                            setValidaBoton(true);
                            setModalProgreso(false);
                          });
                      }
                    })
                    .catch((error) => {
                      swalErrorFactura(error);
                      submittingRef.current = false;
                      setValidaBoton(true);
                      setModalProgreso(false);
                    });
                });
              })
              // Catch primer then
              .catch((error) => {
                swalErrorFactura(error);
                submittingRef.current = false;
                setValidaBoton(true);
                setModalProgreso(false);
              });
          } catch (error) {
            swalErrorFactura(error);
            submittingRef.current = false;
            setValidaBoton(true);
            setModalProgreso(false);
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Faltan datos",
            text: "La factura no tiene subtotal o total mayor a cero. Revise los tickets seleccionados.",
          });
          submittingRef.current = false;
          setValidaBoton(true);
          setModalProgreso(false);
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Sin timbres disponibles",
        text: "No hay timbres disponibles para facturar. Contacte a administración.",
      });
      submittingRef.current = false;
      setValidaBoton(true);
      setModalProgreso(false);
    }
  };

  // fromUserChange = true cuando el usuario mueve el select manualmente
  // Con Método de Pago PUE, la forma de pago 99 ("Por definir") es inválida para el SAT
  // (Facturama responde: "Para PUE La Forma de pago no puede ser 99") y el timbrado nunca
  // se logra por más reintentos que se hagan.
  // NO se rellena con un valor por defecto: poner 01 Efectivo automáticamente haría timbrar
  // CFDIs que declaran efectivo aunque hayan pagado con tarjeta. Se deja vacío para que
  // quien factura elija la forma real; el pre-check de arriba impide guardar sin ella.
  const formaPagoPUE = (forma) => (!forma || forma === "99" ? "" : forma);

  function BuscaCliente(id, fromUserChange = false) {
    setSelectedCliente(id);
    setSurtidosData([]);

    setInputFields([
      {
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      },
    ]);

    clientes.map((a) => {
      if (a._id == id) {
        setSelectedColaborador(a.vendedor[0]._id);

        // Actualiza datos fiscales si:
        // - el usuario cambió el select manualmente (siempre actualiza y limpia override)
        // - o no hay override activo (carga inicial sin datos personalizados del modal)
        if (!facturarPublicoGeneral && (fromUserChange || !billingOverriddenRef.current)) {
          if (fromUserChange) { billingOverriddenRef.current = false; setBillingOverridden(false); }
          setCondicionesPagoSATCliente(a.condicionesPagoSAT);
          setRfcCliente(a.RFC);
          setNombreCliente(a.razon_social);
          setUsoCFDICliente(a.usoCFDI);
          setRegFiscalCliente(a.regFiscal);
          setCpCliente(a.cp);

          if (a.metodoPagoSAT != "PPD") {
            // Con PUE el SAT rechaza la forma de pago 99 ("Por definir").
            // Si el catálogo del cliente la trae en 99 (o vacía), se usa 01 Efectivo por defecto.
            setFormaPagoSATCliente(formaPagoPUE(a.formaPagoSAT));
            setMetodoPagoSATCliente(a.metodoPagoSAT);
          } else {
            setFormaPagoSATCliente("99");
            setMetodoPagoSATCliente(a.metodoPagoSAT);
          }
        }

        setDatosClientePrevios({
          condicionesPagoSATCliente: a.condicionesPagoSAT,
          formaPagoSATCliente:
            a.metodoPagoSAT !== "PPD" ? formaPagoPUE(a.formaPagoSAT) : "99",
          metodoPagoSATCliente: a.metodoPagoSAT,
          rfcCliente: a.RFC,
          nombreCliente: a.razon_social,
          usoCFDICliente: a.usoCFDI,
          regFiscalCliente: a.regFiscal,
          cpCliente: a.cp,
        });
      }
    });

    axios
      .get(`${URL_VENTAS_TIENDAS}Facturacion/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSurtidos = res.data;
        let arrayTabla = allSurtidos.map((a) => {
          return {
            id: uuidv4(),
            surtidos: a._id,
            idSurtido: a.prefijo + " " + a.consecutivo,
            total: parseFloat(a.total_general),
            subTotal: parseFloat(a.subTotal),
            iva: parseFloat(a.iva || 0),
            descuento: parseFloat(a.descuento) || 0,
            totalCantidad: a.total_cantidad,
            colaboradores: a.colaboradores && a.colaboradores[0] ? a.colaboradores[0]._id : "",
          };
        });
        let dataFinal = Object.values(arrayTabla);
        setSurtidos(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function BuscaEmpresa(event) {
    setSelectedEmpresa(event.target.value);

    empresas.map((a) => {
      if (a._id == event.target.value) {
        setCpEmpresa(a.cp);
        setRfcEmpresa(a.rfc);
        setNombreEmpresa(a.razonSocial);
        setRegFiscalEmpresa(a.regimenFiscal);
      }
    });
    setInputFields([
      {
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      },
    ]);
    if (event.target.value != "" && selectedCliente != "") {
      axios
        .get(`${URL_VENTAS_TIENDAS}Facturacion/${selectedCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSurtidos = res.data;
          let arrayTabla = allSurtidos.map((a) => {
            return {
              id: uuidv4(),
              surtidos: a._id,
              idSurtido: a.prefijo + " " + a.consecutivo,
              total: parseFloat(a.total_general),
              subTotal: parseFloat(a.subTotal),
              iva: parseFloat(a.iva || 0),
              descuento: parseFloat(a.descuento) || 0,
              totalCantidad: a.total_cantidad,
              colaboradores: a.colaboradores && a.colaboradores[0] ? a.colaboradores[0]._id : "",
            };
          });
          let dataFinal = Object.values(arrayTabla);
          setSurtidos(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  async function BuscaSurtido(id, surtidoValue) {
    setSurtidosData([]);

    if (!surtidoValue) {
      setInputFields(
        inputFields.map((i) => (i.id === id ? { ...i, surtidos: "" } : i))
      );
      return;
    }

    if (inputFields.some((e) => e.surtidos === surtidoValue)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El surtido ya fue capturado!",
        showConfirmButton: false,
      });

      setInputFields(
        inputFields.map((i) => (i.id === id ? { ...i, surtidos: "" } : i))
      );
      return;
    }

    try {
      surtidos.map((a) => {
        if (a.surtidos == surtidoValue) {
          // Toma el vendedor REAL de la nota (no el asignado al cliente)
          if (a.colaboradores) setSelectedColaborador(a.colaboradores);
          let surtidos = a.surtidos;
          let idSurtido = a.idSurtido;
          let total = a.total;
          let subTotal = a.subTotal;
          let iva = a.iva;
          let descuento = a.descuento;
          let totalCantidad = a.totalCantidad;
          handleChangeInputArticulo(
            id,
            surtidos,
            idSurtido,
            total,
            subTotal,
            iva,
            descuento,
            totalCantidad
          );
        }
      });

      const response = await axios.get(
        `${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${surtidoValue}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      if (!response.data.length) {
        console.warn("La API no devolvió datos");
        return;
      }

      let allArticulosSurtido = response.data;
      let colorTallaCantidad = {};

      allArticulosSurtido.forEach((a) => {
        const color = a.colores[0].name;
        const talla = a.tallas[0].name;
        const cantidad = a.cantidad;

        if (!colorTallaCantidad[talla]) {
          colorTallaCantidad[talla] = {};
        }
        if (!colorTallaCantidad[talla][color]) {
          colorTallaCantidad[talla][color] = 0;
        }
        colorTallaCantidad[talla][color] += cantidad;
      });

      const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
        const indexA = customSizeOrder.indexOf(a);
        const indexB = customSizeOrder.indexOf(b);
        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      const colores = [
        ...new Set(allArticulosSurtido.map((a) => a.colores[0].name)),
      ].sort();

      setSurtidosData(
        tallas.map((talla) => {
          // Buscar el primer artículo con esta talla
          const articulo = allArticulosSurtido.find(
            (a) => a.tallas[0]?.name === talla
          );

          return {
            talla,
            nombreArticulo: articulo?.articulos?.[0]?.nombre || "Desconocido",
            precio: articulo?.precio || 0,
            colores: colores.map((color) => ({
              color,
              cantidad: colorTallaCantidad[talla]?.[color] || 0,
            })),
          };
        })
      );
    } catch (err) {
      console.error("Error en la petición a la API:", err);
    }
  }

  const handleChangeInputArticulo = (
    id,
    surtidos,
    idSurtido,
    total,
    subTotal,
    iva,
    descuento,
    totalCantidad
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.surtidos = surtidos;
        i.idSurtido = idSurtido;
        i.total = total;
        i.subTotal = subTotal;
        i.iva = iva;
        i.descuento = descuento;
        i.totalCantidad = totalCantidad;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  function ActualizaTotales(fields) {
    const source = fields || inputFields;
    let tcan = source.map((c) => parseFloat(c.totalCantidad));
    let TDCan = tcan.reduce((t, total, index) => t + total, 0);
    setTotalCant(TDCan);

    let totalSum = source.reduce((t, c) => t + parseFloat(c.total), 0);
    let subTotalSum = source.reduce((t, c) => t + parseFloat(c.subTotal || 0), 0);
    let ivaSum = source.reduce((t, c) => t + parseFloat(c.iva || 0), 0);
    let descPorcentaje = source.length > 0 ? parseFloat(source[0].descuento) || 0 : 0;

    setDescuentoPorcentaje(descPorcentaje);
    setDescuentoNumero(parseFloat((subTotalSum * descPorcentaje / 100).toFixed(2)));
    setSubTotal(parseFloat(subTotalSum.toFixed(2)));
    setIva(parseFloat(ivaSum.toFixed(2)));
    setTotal(parseFloat(totalSum.toFixed(2)));
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ventasTiendas ? (
        <div className="card container col-11">
          <h3 align="center">Nueva Factura</h3>
          <Form onSubmit={saveFacturaNuevo}>
            <Row>
              <Col md={2}>
                <Label>Timbres Disponibles</Label>
                <Input
                  type="text"
                  value={timbresDisponibles}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Factura</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label>Empresa</Label>
                <Input
                  style={{ backgroundColor: "yellow" }}
                  name="empresa"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(event) => {
                    BuscaEmpresa(event);
                  }}
                >
                  <option value="">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.listoFacturar == "Si" && a.is_active == "Si") {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Serie (Tienda)</Label>
                <Input
                  type="text"
                  value={serieTienda || "—"}
                  title="Serie fiscal asignada a esta tienda"
                  disabled
                />
              </Col>
            </Row>
            <Row>
              {selectedCliente != CLIENTES_DIVERSOS ? (
                <Col md={3} className="mt-3">
                  <Button
                    color={facturarPublicoGeneral ? "danger" : "primary"}
                    onClick={() => {
                      const nuevoEstado = !facturarPublicoGeneral;
                      setFacturarPublicoGeneral(nuevoEstado);

                      if (nuevoEstado) {
                        // Activar Clientes Diversos
                        setCondicionesPagoSATCliente("Contado");
                        setFormaPagoSATCliente("04");
                        setMetodoPagoSATCliente("PUE");
                        setRfcCliente("XAXX010101000");
                        setNombreCliente("Clientes Diversos");
                        setUsoCFDICliente("S01");
                        setRegFiscalCliente("616");
                        setCpCliente("06000");
                      } else {
                        // Restaurar cliente previo si existe
                        if (datosClientePrevios.rfcCliente) {
                          setCondicionesPagoSATCliente(
                            datosClientePrevios.condicionesPagoSATCliente
                          );
                          setFormaPagoSATCliente(
                            datosClientePrevios.formaPagoSATCliente
                          );
                          setMetodoPagoSATCliente(
                            datosClientePrevios.metodoPagoSATCliente
                          );
                          setRfcCliente(datosClientePrevios.rfcCliente);
                          setNombreCliente(datosClientePrevios.nombreCliente);
                          setUsoCFDICliente(datosClientePrevios.usoCFDICliente);
                          setRegFiscalCliente(
                            datosClientePrevios.regFiscalCliente
                          );
                          setCpCliente(datosClientePrevios.cpCliente);
                        }
                      }
                    }}
                  >
                    {facturarPublicoGeneral
                      ? "❌ Quitar Clientes Diversos"
                      : "✔ Facturar a Clientes Diversos"}
                  </Button>
                </Col>
              ) : (
                <Col md={3} className="mt-3">
                  <Button
                    color="info"
                    onClick={() => {
                      // Limpiar campos para que el usuario escriba datos frescos sin concatenar con XAXX
                      setRfcCliente("");
                      setNombreCliente("");
                      setCondicionesPagoSATCliente("");
                      setFormaPagoSATCliente("");
                      setMetodoPagoSATCliente("");
                      setUsoCFDICliente("");
                      setRegFiscalCliente("");
                      setCpCliente("");
                      toggleCustomFactura();
                    }}
                  >
                    Facturar a otro Nombre
                  </Button>
                  {billingOverridden && (
                    <div style={{ marginTop: "8px", padding: "8px 12px", background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "6px", fontSize: "12px", color: "#1b5e20" }}>
                      <strong>✔ Se facturará a:</strong><br />
                      <span><strong>Nombre:</strong> {nombreCliente}</span><br />
                      <span><strong>RFC:</strong> {rfcCliente}</span><br />
                      {cpCliente && <span><strong>CP:</strong> {cpCliente}&nbsp;&nbsp;</span>}
                      {regFiscalCliente && <span><strong>Reg. Fiscal:</strong> {regFiscalCliente}</span>}
                    </div>
                  )}
                </Col>
              )}
              <Col md={2}>
                <Label>Cliente</Label>
                <Input
                  type="select"
                  value={selectedCliente}
                  required
                  onChange={(event) => {
                    BuscaCliente(event.target.value, true);
                  }}
                >
                  <option value="">Selecciona un Cliente</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.razon_social} / {a.nombre_comercial}
                        </option>
                      );
                    })}
                </Input>
              </Col>

              {/* Vista de solo lectura de lo que se va a enviar al SAT como receptor.
                  rfcCliente/nombreCliente se congelan en la factura al guardar, así que
                  si el catálogo de Clientes tiene un typo hay que verlo AQUÍ, antes de
                  guardar — no hasta que Facturama lo rechace. Solo se edita seleccionando
                  otro cliente o vía "Facturar a otro Nombre"; nunca escribiendo aquí. */}
              {nombreCliente && (
                <Col md={3}>
                  <Label>Se facturará a (según catálogo)</Label>
                  <Input type="text" value={nombreCliente} disabled title="Nombre/Razón Social que se enviará al SAT" />
                  <Input type="text" value={rfcCliente} disabled className="mt-1" title="RFC que se enviará al SAT" />
                </Col>
              )}

              {/* <Col md={2}>
                <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaborador}
                      required
                      onChange={(event) => {
                        BuscaColaborador(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {colaboradores
                        .sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre} {a.apellido} </option>
                          );
                      })}
                    </Input>
                  </Col> */}

              <Col md={2}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  style={{ backgroundColor: "yellow" }}
                  type="select"
                  value={formaPagoSATCliente}
                  required
                  onChange={(e) => {
                    setFormaPagoSATCliente(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="01"> 01 Efectivo</option>
                  <option value="02"> 02 Cheque nominativo</option>
                  <option value="03">
                    {" "}
                    03 Transferencia electrónica de fondos
                  </option>
                  <option value="04"> 04 Tarjeta de crédito</option>
                  <option value="05"> 05 Monedero electrónico</option>
                  <option value="06"> 06 Dinero electrónico</option>
                  <option value="08"> 08 Vales de despensa</option>
                  <option value="12"> 12 Dación en pago</option>
                  <option value="13"> 13 Pago por subrogación</option>
                  <option value="14"> 14 Pago por consignación</option>
                  <option value="15"> 15 Condonación</option>
                  <option value="17"> 17 Compensación</option>
                  <option value="23"> 23 Novación</option>
                  <option value="24"> 24 Confusión</option>
                  <option value="25"> 25 Remisión de deuda</option>
                  <option value="26"> 26 Prescripción o caducidad</option>
                  <option value="27"> 27 A satisfacción del acreedor</option>
                  <option value="28"> 28 Tarjeta de débito</option>
                  <option value="29"> 29 Tarjeta de servicios</option>
                  <option value="30"> 30 Aplicación de anticipos</option>
                  <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

              <Col md={2}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSATCliente}
                  required
                  onChange={(e) => {
                    setMetodoPagoSATCliente(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
                  <option value="PPD">
                    PPD (Pago en Parcialidades o Diferido)
                  </option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Autorizacion TDC (4 Digitos)
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Nota</Label>
              </Col>
            </Row>
            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={4}>
                    <Autocomplete
                      size="small"
                      value={
                        surtidos.find((s) => s.surtidos === inputField.surtidos) || null
                      }
                      onChange={(event, selected) => {
                        BuscaSurtido(inputField.id, selected ? selected.surtidos : "");
                      }}
                      options={[...surtidos].sort((a, b) =>
                        a.idSurtido > b.idSurtido ? 1 : -1
                      )}
                      getOptionLabel={(option) =>
                        option
                          ? `Venta: ${option.idSurtido} / ${new Intl.NumberFormat(
                              "es-MX",
                              { style: "currency", currency: "MXN" }
                            ).format(option.total)}`
                          : ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.surtidos === value.surtidos
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona Venta"
                          variant="outlined"
                          required
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option.surtidos}>
                          Venta: {option.idSurtido} /{" "}
                          {new Intl.NumberFormat("es-MX", {
                            style: "currency",
                            currency: "MXN",
                          }).format(option.total)}
                        </li>
                      )}
                    />
                  </Col>

                  {/* <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col> */}
                </Row>
              </div>
            ))}

            {/* Tabla Articulos */}
            {surtidosData.length > 0 && (
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Articulo</th>
                          <th>Talla</th>
                          {surtidosData[0].colores.map((c, index) => (
                            <th key={index}>{c.color}</th>
                          ))}
                          <th>Total Piezas</th>
                          <th>Precio</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {surtidosData.map((surtido, index) => {
                          const totalFila = surtido.colores.reduce(
                            (sum, c) => sum + c.cantidad,
                            0
                          );
                          return (
                            <tr key={index}>
                              <td>{surtido.nombreArticulo}</td>
                              <td>{surtido.talla}</td>
                              {surtido.colores.map((c, i) => (
                                <td key={i}>{c.cantidad}</td>
                              ))}
                              <td>
                                <strong>{totalFila}</strong>
                              </td>
                              <td>
                                {new Intl.NumberFormat("es-MX", {
                                  style: "currency",
                                  currency: "MXN",
                                }).format(surtido.precio)}
                              </td>
                              <td>
                                <strong>
                                  {new Intl.NumberFormat("es-MX", {
                                    style: "currency",
                                    currency: "MXN",
                                  }).format(totalFila * surtido.precio)}
                                </strong>
                              </td>
                            </tr>
                          );
                        })}

                        {/* Fila de totales por columna */}
                        <tr>
                          <td></td>
                          <td>
                            <strong>Total</strong>
                          </td>
                          {surtidosData[0].colores.map((_, i) => {
                            const totalColumna = surtidosData.reduce(
                              (sum, surtido) =>
                                sum + surtido.colores[i].cantidad,
                              0
                            );
                            return (
                              <td key={i}>
                                <strong>{totalColumna}</strong>
                              </td>
                            );
                          })}
                          <td>
                            <strong>
                              {surtidosData.reduce(
                                (sum, surtido) =>
                                  sum +
                                  surtido.colores.reduce(
                                    (s, c) => s + c.cantidad,
                                    0
                                  ),
                                0
                              )}
                            </strong>
                          </td>{" "}
                          {/* Total general */}
                          <td></td>
                          <td>
                            <strong>
                              {new Intl.NumberFormat("es-MX", {
                                style: "currency",
                                currency: "MXN",
                              }).format(
                                surtidosData.reduce(
                                  (sum, surtido) =>
                                    sum +
                                    surtido.colores.reduce(
                                      (s, c) => s + c.cantidad,
                                      0
                                    ) *
                                      surtido.precio,
                                  0
                                )
                              )}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            <br />
            <br />
            <Row>
              <Col>
                <Label className="mr-sm-2">Subtotal</Label>
                <Input type="number" value={subTotal} disabled />
              </Col>
              <Col>
                <Label className="mr-sm-2">IVA</Label>
                <Input type="number" value={iva} disabled />
              </Col>
              <Col>
                <Label className="mr-sm-2">Total</Label>
                <Input type="number" value={total} disabled />
              </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/MenuTiendas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      {/* Add this modal right after your existing modalProgreso modal */}
      <Modal isOpen={modalCustomFactura} toggle={toggleCustomFactura}>
        <ModalHeader toggle={toggleCustomFactura}>
          <h4>Datos de Facturación</h4>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Nombre/Razón Social</Label>
                  <Input
                    type="text"
                    value={nombreCliente}
                    onChange={(e) => setNombreCliente(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>RFC</Label>
                  <Input
                    type="text"
                    value={rfcCliente}
                    onChange={(e) => setRfcCliente(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Condiciones de Pago</Label>
                  <Input
                    type="text"
                    value={condicionesPagoSATCliente}
                    onChange={(e) =>
                      setCondicionesPagoSATCliente(e.target.value)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Código Postal</Label>
                  <Input
                    type="text"
                    value={cpCliente}
                    onChange={(e) => setCpCliente(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Forma de Pago</Label>
                  <Input
                    type="select"
                    value={formaPagoSATCliente}
                    onChange={(e) => setFormaPagoSATCliente(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="01"> 01 Efectivo</option>
                    <option value="02"> 02 Cheque nominativo</option>
                    <option value="03">
                      {" "}
                      03 Transferencia electrónica de fondos
                    </option>
                    <option value="04"> 04 Tarjeta de crédito</option>
                    <option value="05"> 05 Monedero electrónico</option>
                    <option value="06"> 06 Dinero electrónico</option>
                    <option value="08"> 08 Vales de despensa</option>
                    <option value="12"> 12 Dación en pago</option>
                    <option value="13"> 13 Pago por subrogación</option>
                    <option value="14"> 14 Pago por consignación</option>
                    <option value="15"> 15 Condonación</option>
                    <option value="17"> 17 Compensación</option>
                    <option value="23"> 23 Novación</option>
                    <option value="24"> 24 Confusión</option>
                    <option value="25"> 25 Remisión de deuda</option>
                    <option value="26"> 26 Prescripción o caducidad</option>
                    <option value="27"> 27 A satisfacción del acreedor</option>
                    <option value="28"> 28 Tarjeta de débito</option>
                    <option value="29"> 29 Tarjeta de servicios</option>
                    <option value="30"> 30 Aplicación de anticipos</option>
                    <option value="99"> 99 Por definir</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Método de Pago</Label>
                  <Input
                    type="select"
                    value={metodoPagoSATCliente}
                    onChange={(e) => setMetodoPagoSATCliente(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="PUE">
                      PUE (Pago de Una Sola Exhibición)
                    </option>
                    <option value="PPD">
                      PPD (Pago en Parcialidades o Diferido)
                    </option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Uso de CFDI</Label>
                  <Input
                    type="select"
                    value={usoCFDICliente}
                    onChange={(e) => setUsoCFDICliente(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="G01">G01 - Adquisición de mercancías</option>
                    <option value="G02">
                      G02 - Devoluciones, descuentos o bonificaciones
                    </option>
                    <option value="G03">G03 - Gastos en general</option>
                    <option value="I01">I01 - Construcciones</option>
                    <option value="I02">
                      I02 - Mobiliario y equipo de oficina
                    </option>
                    <option value="I03">I03 - Equipo de transporte</option>
                    <option value="I04">I04 - Equipo de cómputo</option>
                    <option value="I05">
                      I05 - Dados, troqueles, moldes, matrices y herramental
                    </option>
                    <option value="I06">
                      I06 - Comunicaciones telefónicas
                    </option>
                    <option value="I07">
                      I07 - Comunicaciones satelitales
                    </option>
                    <option value="I08">I08 - Otra maquinaria y equipo</option>
                    <option value="D01">
                      D01 - Honorarios médicos, dentales y gastos hospitalarios
                    </option>
                    <option value="D02">
                      D02 - Gastos médicos por incapacidad o discapacidad
                    </option>
                    <option value="D03">D03 - Gastos funerales</option>
                    <option value="D04">D04 - Donativos</option>
                    <option value="D05">
                      D05 - Intereses reales efectivamente pagados por créditos
                      hipotecarios
                    </option>
                    <option value="D06">
                      D06 - Aportaciones voluntarias al SAR
                    </option>
                    <option value="D07">
                      D07 - Primas por seguros de gastos médicos
                    </option>
                    <option value="D08">
                      D08 - Gastos de transportación escolar obligatoria
                    </option>
                    <option value="D09">
                      D09 - Depósitos en cuentas para el ahorro
                    </option>
                    <option value="D10">
                      D10 - Pagos por servicios educativos
                    </option>
                    <option value="P01">P01 - Por definir</option>
                    <option value="S01">S01 - Sin efectos fiscales</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Régimen Fiscal</Label>
                  <Input
                    type="select"
                    value={regFiscalCliente}
                    onChange={(e) => setRegFiscalCliente(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="601">
                      601 - General de Ley Personas Morales
                    </option>
                    <option value="603">
                      603 - Personas Morales con Fines no Lucrativos
                    </option>
                    <option value="605">
                      605 - Sueldos y Salarios e Ingresos Asimilados a Salarios
                    </option>
                    <option value="606">606 - Arrendamiento</option>
                    <option value="607">
                      607 - Régimen de Enajenación o Adquisición de Bienes
                    </option>
                    <option value="608">608 - Demás ingresos</option>
                    <option value="609">609 - Consolidación</option>
                    <option value="610">
                      610 - Residentes en el Extranjero sin Establecimiento
                      Permanente en México
                    </option>
                    <option value="611">
                      611 - Ingresos por Dividendos (socios y accionistas)
                    </option>
                    <option value="612">
                      612 - Personas Físicas con Actividades Empresariales y
                      Profesionales
                    </option>
                    <option value="614">614 - Ingresos por intereses</option>
                    <option value="616">616 - Sin obligaciones fiscales</option>
                    <option value="620">
                      620 - Sociedades Cooperativas de Producción que optan por
                      diferir sus ingresos
                    </option>
                    <option value="621">621 - Incorporación Fiscal</option>
                    <option value="622">
                      622 - Actividades Agrícolas, Ganaderas, Silvícolas y
                      Pesqueras
                    </option>
                    <option value="623">
                      623 - Opcional para Grupos de Sociedades
                    </option>
                    <option value="624">624 - Coordinados</option>
                    <option value="625">
                      625 - Régimen de las Actividades Empresariales con
                      ingresos a través de Plataformas Tecnológicas
                    </option>
                    <option value="626">
                      626 - Régimen Simplificado de Confianza
                    </option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              setDatosClientePrevios({
                condicionesPagoSATCliente,
                formaPagoSATCliente,
                metodoPagoSATCliente,
                rfcCliente,
                nombreCliente,
                usoCFDICliente,
                regFiscalCliente,
                cpCliente,
              });
              // Marcar que el usuario ingresó datos personalizados — no sobreescribir
              billingOverriddenRef.current = true;
              setBillingOverridden(true);
              toggleCustomFactura();
            }}
          >
            Guardar
          </Button>
          <Button color="secondary" onClick={toggleCustomFactura}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default FacturasTiendasCreate;
